import { PrinterPosIcon } from './PrinterPosIcon';

/**
 * author: Michael Richins
 * id F9D30BAE-7AF6-4C02-83AD-18045895B8B0
 * name printer-pos
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleIcon = PrinterPosIcon;
export default PrinterPointOfSaleIcon